import { Injectable } from '@angular/core';
import * as CryptoTS from 'crypto-ts';
import * as CryptoJS from 'crypto-js'
@Injectable({
  providedIn: 'root'
})
export class EncryptedServiceService {

  key: string = "z!!!!!!!1sdfadsf56adf456asdfasdf";

  constructor() {}

  encryptionAES (msg) {
    // Encrypt
    return msg.toString();
  }

  decryptionAES (msg) {
    // Decrypt
    return msg;
  }

  decryptRes(data: string): string {
    return data;
  }
}
